import { PropType } from 'vue'
import type { ExtractPropTypes } from 'vue'

export const T_TEXTAREA_PROPS = {
  name: { type: String, required: true },
  modelValue: { type: String as PropType<string | null>, default: '' },
  label: { type: String, default: '' },
  help: { type: String, default: '' },
  tooltip: { type: String, default: '' },
  rules: { type: Object as PropType<any>, default: undefined },
  testId: { type: String, default: undefined },
  hideLabel: { type: Boolean, default: false },
  hideErrorMessage: { type: Boolean, default: false },
}

export type TTextareaProps = ExtractPropTypes<typeof T_TEXTAREA_PROPS>
